var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-form',_vm._b({staticClass:"app-container"},'app-form',_vm.form,false))}
var staticRenderFns = []

export { render, staticRenderFns }